"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const iterator_to_array_1 = require("./iterator-to-array");
function max(...things) {
    if (things.length === 1) {
        things = things[0];
    }
    let array = iterator_to_array_1.iteratorToArray(things);
    array.sort((a, b) => {
        return a < b ? 1 : -1;
    });
    return array[0];
}
exports.max = max;
